import { Laptop, Moon, Sun } from "lucide-react";
import type { ThemePreference } from "../types";

const choices: Array<{ value: ThemePreference; label: string; icon: typeof Sun }> = [
  { value: "system", label: "跟随系统", icon: Laptop },
  { value: "light", label: "浅色", icon: Sun },
  { value: "dark", label: "深色", icon: Moon },
];

export function ThemeToggle({ value, onChange }: { value: ThemePreference; onChange: (value: ThemePreference) => void }) {
  const current = choices.findIndex((choice) => choice.value === value);
  const choice = choices[current] ?? choices[0];
  const Icon = choice.icon;
  return (
    <button
      type="button"
      className="icon-button theme-toggle"
      aria-label={`${choice.label}，点击切换主题`}
      title={choice.label}
      onClick={() => onChange(choices[(current + 1) % choices.length].value)}
    >
      <Icon size={18} />
    </button>
  );
}
